const BASE_URL = 'https://api.happer.fr/api/'

const APIS = {
    SEND_CODE_API: BASE_URL + 'v1/admin/auth/login-code',
    LOGIN_API: BASE_URL + 'v1/admin/auth/login',
    ADMIN_USERS: BASE_URL + 'v1/admin/get-all-admins?page=',
    DELETE_ADMIN_USER:BASE_URL+'v1/admin/delete-admin/',
    GET_ADMIN_DETAILS:BASE_URL+'v1/admin/get-admin/',
    GET_ROLES: BASE_URL + 'roles',
    CREATE_ADMIN_USER: BASE_URL + 'admin_users',
    GET_USERS: BASE_URL + 'v1/admin/users/get-all-users?page=',
    DELETE_USER:BASE_URL+'admin/users/delete-user/',
    USER_EDIT:BASE_URL+'v1/admin/users/edit-user/',
    ADD_USER:BASE_URL+'v1/admin/users/add-user',
    CHECK_USERNAME_AVAILABILITY: BASE_URL + 'v1/admin/users/check-username-availability',
    GET_USER_DETAIL:BASE_URL+'v1/admin/users/get-user/',
UPLOAD_PROFILE_IMAGE:BASE_URL+'v1/common/file-upload',


    GET_PRODUCTS: BASE_URL + 'products',
    GET_ALL_ADMIN_PRODUCTS: BASE_URL + 'v1/admin/products/get-all-products',
    ADD_ADMIN_PRODUCT: BASE_URL + 'v1/admin/products/add-product',
    GET_ADMIN_PRODUCT: BASE_URL + 'v1/admin/products/get-product/',
    GET_PRODUCT_VARIANTS: BASE_URL + 'v1/admin/products/get-product-variants/',
    DELETE_ADMIN_PRODUCT: BASE_URL + 'v1/admin/products/delete-product/',
    GET_ITEMS: BASE_URL + 'items',
    SELFIES: BASE_URL + 'selfies/admin',
    // Carts (admin)
    GET_CARTS: BASE_URL + 'carts', // legacy user carts
    GET_ALL_ADMIN_CARTS: BASE_URL + 'v1/admin/carts/get-all-carts',
    GET_ADMIN_CART: BASE_URL + 'v1/admin/carts/get-cart/',
    GET_ALL_ADMIN_BRANDS: BASE_URL + 'v1/admin/brands/get-all-brands',
    ADD_ADMIN_BRAND: BASE_URL + 'v1/admin/brands/add-brand',
    EDIT_ADMIN_BRAND: BASE_URL + 'v1/admin/brands/edit-brand/',
    GET_ADMIN_BRAND: BASE_URL + 'v1/admin/brands/get-brand/',
    DELETE_ADMIN_BRAND: BASE_URL + 'v1/admin/brands/delete-brand/',
    GET_HAPPER_VARIABLE: BASE_URL + 'happer_var',
    GET_CREDIT_CODES: BASE_URL + 'promo_codes',
    GET_ALL_ADMIN_CATEGORIES: BASE_URL + 'v1/admin/categories/get-all-categories',
    ADD_ADMIN_CATEGORY: BASE_URL + 'v1/admin/categories/add-category',
    EDIT_ADMIN_CATEGORY: BASE_URL + 'v1/admin/categories/edit-category/',
    GET_ADMIN_CATEGORY: BASE_URL + 'v1/admin/categories/get-category/',
    DELETE_ADMIN_CATEGORY: BASE_URL + 'v1/admin/categories/delete-category/',
    GET_ALL_ADMIN_SUBCATEGORIES: BASE_URL + 'v1/admin/subcategories/get-all-subcategories',
    ADD_ADMIN_SUBCATEGORY: BASE_URL + 'v1/admin/subcategories/add-subcategory',
    EDIT_ADMIN_SUBCATEGORY: BASE_URL + 'v1/admin/subcategories/edit-subcategory/',
    GET_ADMIN_SUBCATEGORY: BASE_URL + 'v1/admin/subcategories/get-subcategory/',
    DELETE_ADMIN_SUBCATEGORY: BASE_URL + 'v1/admin/subcategories/delete-subcategory/',
    GET_ALL_ADMIN_SELFIES: BASE_URL + 'v1/admin/selfies/get-all-selfies',
    ADD_ADMIN_SELFIE: BASE_URL + 'v1/admin/selfies/add-selfie',
    EDIT_ADMIN_SELFIE: BASE_URL + 'v1/admin/selfies/edit-selfie/',
    GET_ADMIN_SELFIE: BASE_URL + 'v1/admin/selfies/get-selfie/',
    DELETE_ADMIN_SELFIE: BASE_URL + 'v1/admin/selfies/delete-selfie/',
    GET_ITEMS_API: BASE_URL + 'items',
    EDIT_USER_API: BASE_URL + 'users/admin/',
    CREATE_USER_API: BASE_URL + 'users',
    ADD_CREDIT_CODE: BASE_URL + 'promo_codes/user',
    SEND_NOTIFICATION_API: BASE_URL + 'notifications/back_office/sendAll',
    ADD_SELFIE: BASE_URL + 'selfies',
    GET_INFLUENCERS: BASE_URL + 'users?users_type=1',
    GET_ALL_LINKED_PRODUCTS: BASE_URL + 'v1/admin/linked-products/get-all-linked-products',
    ADD_LINKED_PRODUCT: BASE_URL + 'v1/admin/linked-products/add-linked-product',
    GET_LINKED_PRODUCT: BASE_URL + 'v1/admin/linked-products/get-linked-product/',
    DELETE_LINKED_PRODUCT: BASE_URL + 'v1/admin/linked-products/delete-linked-product/',


    // DASHBOARDAPI

    // 'backoffice/notification/flags',
    // 'backoffice/metrics/total_happ',
    // 'backoffice/metrics/total_wish',
    // 'backoffice/metrics/users_connection',
    // 'backoffice/metrics/users_total',
    // 'backoffice/metrics/users_free',
    // 'backoffice/metrics/users_premium',
    // 'backoffice/metrics/users_register',
    // 'backoffice/metrics/users_winner?start_date=',
    // 'backoffice/metrics/sponsorship',
    // 'backoffice/metrics/reconnection',
    // 'backoffice/metrics/credits_today',
    // 'backoffice/metrics/pictures_today',
    // 'backoffice/metrics/charts_month',
    // 'backoffice/metrics/charts_week',
    // 'backoffice/metrics/charts_days'
    GET_NOTIFICATION_FLAGS: BASE_URL + 'backoffice/notification/flags',

    GET_METRICS_TOTAL_HAPP: BASE_URL + 'backoffice/metrics/total_happ',
    GET_METRICS_TOTAL_WISH: BASE_URL + 'backoffice/metrics/total_wish',

    GET_USERS_CONNECTION: BASE_URL + 'backoffice/metrics/users_connection',
    GET_USERS_TOTAL: BASE_URL + 'backoffice/metrics/users_total',
    GET_USERS_FREE: BASE_URL + 'backoffice/metrics/users_free',
    GET_USERS_PREMIUM: BASE_URL + 'backoffice/metrics/users_premium',
    GET_USERS_REGISTER: BASE_URL + 'backoffice/metrics/users_register',
    GET_USERS_WINNER: BASE_URL + 'backoffice/metrics/users_winner?start_date=',

    GET_METRICS_SPONSORSHIP: BASE_URL + 'backoffice/metrics/sponsorship',
    GET_METRICS_RECONNECTION: BASE_URL + 'backoffice/metrics/reconnection',
    GET_CREDITS_TODAY: BASE_URL + 'backoffice/metrics/credits_today',
    GET_PICTURES_TODAY: BASE_URL + 'backoffice/metrics/pictures_today',

    GET_CHARTS_MONTH: BASE_URL + 'backoffice/metrics/charts_month',
    GET_CHARTS_WEEK: BASE_URL + 'backoffice/metrics/charts_week',
    GET_CHARTS_DAYS: BASE_URL + 'backoffice/metrics/charts_days',
    GET_ME_DETAILS: BASE_URL + 'admin_users/',

























}

export {
    APIS, BASE_URL
}